import React, { Component } from 'react';
import { WidgetHelper } from './WidgetHelper';
import { OfferService, ReferenceService, JobSeekerService } from '../Services';
import { SearchOffersKeywordsWidget } from './SearchOffer';
import { CountTo } from '../Components';
import { IDropDownValue, IDropDownValueChildren } from '../Models';
import { IReferenceSousDomaine } from '../Models/Reference/IReferenceDomains';

interface IHomePageOffersProps {
    showOfferSearchEngine: string | undefined;
    bannerSentence: string | undefined;
    offerEncodingLabel: string | undefined;
    offerEncodingLink: string | undefined;
    dictToday: string;
    dictOffersAvailable: string;
    dictNbSelectedDomain: string;
    dictSearchBy: string;
    dictJobsSkillsKeywords: string;
    dictSelectedDomain: string;
    dictDomain: string;
    dictSearch: string;
    dictRemoveFilter: string;
    dictWorkFamilies: string;
    offerSearchUrl: string;
}

interface IHomePageOffersState {
    bannerSentence: string[] | undefined;
    offerCount: number;
    domains: IDropDownValue[];
}

export class HomePageOffersWidget extends Component<
    IHomePageOffersProps,
    IHomePageOffersState
> {
    constructor(props: IHomePageOffersProps) {
        super(props);
        this.state = {
            bannerSentence: this.props.bannerSentence!.split('{{offerNumber}}'),
            offerCount: 0,
            domains: [],
        };
    }

    async getOffersDomains() {
        //AboutTimeService.aboutTime('offers').then(async response => {
        //if (response === 200) {
        const data = await ReferenceService.getAllDomains();
        const domains: IDropDownValue[] = data.map((e) => ({
            id: e.id.toString(),
            value: e.name,
            label: e.label,
            checked: false,
            children: this.setChildren(e.subDomain),
            subDomain: this.setChildren(e.subDomain),
        }));
        this.setState({ domains });
        //}
        //});
    }

    private setChildren(e: IReferenceSousDomaine[]): IDropDownValueChildren[] {
        return e.map((b) => ({
            id: b.id.toString(),
            value: b.name,
            label: b.label,
            checked: false,
        }));
    }

    componentDidMount() {
        void this.setOfferCount();
        void this.getOffersDomains();
    }

    async setOfferCount() {
        const offerCount = await OfferService.getOffersCount();
        this.setState({ offerCount });
    }

    render() {
        return (
            <div className="row">
                <div className="col-12 col-md-9 offset-md-2 content">
                    {this.state.bannerSentence && (
                        <h1 className="text-center">
                            {this.state.bannerSentence[0]}

                            {this.state.bannerSentence.length > 1 && (
                                <span className="offerCounts">
                                    {!this.state.offerCount &&
                                        this.state.bannerSentence.length >
                                            1 && (
                                            <CountTo
                                                from={0}
                                                speed={4}
                                                to={60000}
                                                numberToAdd={55}
                                            />
                                        )}
                                    {this.state.offerCount != 0 &&
                                        this.state.bannerSentence.length > 1 &&
                                        this.state.offerCount}
                                    {this.state.bannerSentence[1]}
                                </span>
                            )}
                        </h1>
                    )}
                    {this.props.offerEncodingLabel &&
                        this.props.offerEncodingLink && (
                            <div className="text-center">
                                <a
                                    className="btn-primary action"
                                    href={this.props.offerEncodingLink}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                >
                                    {this.props.offerEncodingLabel}
                                </a>
                            </div>
                        )}
                    {this.props.showOfferSearchEngine &&
                        this.props.showOfferSearchEngine.toUpperCase() ===
                            'TRUE' && (
                            <SearchOffersKeywordsWidget
                                dropdownValueDomains={this.state.domains}
                                keywordInputId={'homeKeywordInput'}
                                dictWorkFamilies={this.props.dictWorkFamilies}
                                domainSelectId={'homeDomainSelect'}
                                offerSearchUrl={this.props.offerSearchUrl}
                                dictNbSelectedDomain={
                                    this.props.dictNbSelectedDomain
                                }
                                dictSearchBy={this.props.dictSearchBy}
                                dictJobsSkillsKeywords={
                                    this.props.dictJobsSkillsKeywords
                                }
                                dictSelectedDomain={
                                    this.props.dictSelectedDomain
                                }
                                dictDomain={this.props.dictDomain}
                                dictSearch={this.props.dictSearch}
                                searchParamsTypeActiris={false}
                                dictRemoveFilter={this.props.dictRemoveFilter}
                                isCovid={false}
                            ></SearchOffersKeywordsWidget>
                        )}
                </div>
            </div>
        );
    }
}

WidgetHelper.register(HomePageOffersWidget, 'home-page-offers-widget');
